module.exports = __webpack_public_path__ + "school/img/practiceSeparateCultureArtThemeBg.1c06231c.jpg";